export default "__VITE_ASSET__dfbd1a39__"